module.exports = __webpack_public_path__ + "img/dad-dog.ab0c4a55.jpg";